import type { AutomaticSettlementPolicy } from "./lessonBlockSaleModel.js";

export function AutomaticSettlementPolicyChoice({
  value,
  onChange,
  name,
  disabled = false,
}: {
  value: AutomaticSettlementPolicy;
  onChange: (value: AutomaticSettlementPolicy) => void;
  name: string;
  disabled?: boolean;
}) {
  return (
    <fieldset className="stack" style={{ marginTop: 12 }}>
      <legend>Credit allocation</legend>
      <label className="row" style={{ alignItems: "start" }}>
        <input
          type="radio"
          name={name}
          value="settle_outstanding_first"
          checked={value === "settle_outstanding_first"}
          onChange={() => onChange("settle_outstanding_first")}
          disabled={disabled}
        />
        <span>
          <strong>Apply to outstanding lessons first</strong>
          <span className="small muted" style={{ display: "block" }}>
            Eligible previous lessons can use credits from this block, oldest first. Any credits left remain available for future lessons.
          </span>
        </span>
      </label>
      <label className="row" style={{ alignItems: "start" }}>
        <input
          type="radio"
          name={name}
          value="no_automatic_backdating"
          checked={value === "no_automatic_backdating"}
          onChange={() => onChange("no_automatic_backdating")}
          disabled={disabled}
        />
        <span>
          <strong>Keep credits for future lessons</strong>
          <span className="small muted" style={{ display: "block" }}>
            Do not automatically apply this block to previous lessons.
          </span>
        </span>
      </label>
    </fieldset>
  );
}
